export default __webpack_public_path__ + "static/318-31c4e1e84079a2f0c5ac41485e57b8d6.gif";